import { useCallback, useMemo } from "react";

export const useAnchor = (href: string | Partial<{ pathname: string; search: string; hash: string; }>, pathname: string) => {
  let hash = ""
  let path = ""
  if (typeof href === "string") {
    const hashArr = href.split("#")
    const pathArr = hashArr[0].split("?")
    hash = hashArr[1]
    path = pathArr[0]
  } else {
    hash = href.hash || ""
    path = href.pathname || ""
  }
  const isAnchor = useMemo(() => {
    return !!hash && path === pathname
  }, [hash, path, pathname])
  const anchorTo = useCallback(() => {
    if (hash) {
      document.getElementById(hash)?.scrollIntoView({ behavior: "smooth", block: "start" })
    }
  }, [hash])
  return {
    isAnchor,
    anchorTo
  }
}